'use strict';

var _parse = require('./parse');

var _parse2 = _interopRequireDefault(_parse);

var _get = require('./get');

var _get2 = _interopRequireDefault(_get);

var _equals = require('./equals');

var _equals2 = _interopRequireDefault(_equals);

var _diff = require('./diff');

var _diff2 = _interopRequireDefault(_diff);

var _isLeapYear = require('./isLeapYear');

var _isLeapYear2 = _interopRequireDefault(_isLeapYear);

var _format = require('./format');

var _format2 = _interopRequireDefault(_format);

var _set = require('./set');

var _set2 = _interopRequireDefault(_set);

var _add = require('./add');

var _add2 = _interopRequireDefault(_add);

var _sub = require('./sub');

var _sub2 = _interopRequireDefault(_sub);

var _min = require('./min');

var _min2 = _interopRequireDefault(_min);

var _max = require('./max');

var _max2 = _interopRequireDefault(_max);

var _isValid = require('./isValid');

var _isValid2 = _interopRequireDefault(_isValid);

var _convertTo = require('./convertTo');

var _convertTo2 = _interopRequireDefault(_convertTo);

var _unixTime = require('./unixTime');

var _unixTime2 = _interopRequireDefault(_unixTime);

var _fromTime = require('./fromTime');

var _fromTime2 = _interopRequireDefault(_fromTime);

var _of = require('./of');

var _of2 = _interopRequireDefault(_of);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//@flow weak
var clone = function clone(date) {
  return new Date(date.getTime());
};

module.exports = {
  of: _of2.default,
  fromTime: _fromTime2.default,
  add: _add2.default,
  clone: clone,
  equals: _equals2.default,
  diff: _diff2.default,
  format: _format2.default,
  get: _get2.default,
  isLeapYear: _isLeapYear2.default,
  parse: _parse2.default,
  set: _set2.default,
  sub: _sub2.default,
  min: _min2.default,
  max: _max2.default,
  isValid: _isValid2.default,
  convertTo: _convertTo2.default,
  unixTime: _unixTime2.default
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/date-fp/build/index.js
// module id = 1387
// module chunks = 0 1 2 3 4 5 7 8 9